import { useBranding } from "@/hooks/useBranding";

/**
 * AppLogo — the universal "brand mark" used everywhere we used to render the
 * Devanagari "श" placeholder. Resolves the live admin-uploaded logo via
 * `useBranding`; falls back to the bundled `/logo.svg` (pk monogram) so the
 * UI is never blank.
 *
 * Pass `size` ('xs' | 'sm' | 'md' | 'lg' | 'xl') or a className override. The
 * image is `eager`-loaded so it ships with the first paint (header logo).
 */
export function AppLogo({ size = "md", className = "", alt = "Paper Kraft Cards", testId }) {
  const { logoUrl } = useBranding();
  const src = logoUrl || "/logo.svg";
  const sizeClass = {
    xs: "w-5 h-5",
    sm: "w-6 h-6",
    md: "w-8 h-8",
    lg: "w-12 h-12",
    xl: "w-16 h-16",
  }[size] || "";
  return (
    <img
      src={src}
      alt={alt}
      className={`${sizeClass} ${className} object-contain select-none`}
      draggable={false}
      loading="eager"
      decoding="async"
      data-testid={testId}
      onError={(e) => {
        // If a custom logo URL 404s (deleted file, expired link), fall back
        // to the bundled SVG so the header never goes blank.
        if (e.currentTarget.src !== window.location.origin + "/logo.svg") {
          e.currentTarget.src = "/logo.svg";
        }
      }}
    />
  );
}

export default AppLogo;
